export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-accent-500/10 via-accent-100/50 to-primary-100/30 rounded-2xl border border-accent-200/40 p-8 md:p-12">
          <div className="flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
                移动客户端
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5 max-w-md mx-auto lg:mx-0">
                随时随地吃瓜不耽误！每日大瓜支持手机浏览器直接访问，页面已针对移动端完美适配。关注我们的社交媒体账号，第一时间获取每日爆料推送，新鲜热瓜不错过。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium cursor-pointer whitespace-nowrap">
                  <i className="ri-smartphone-line"></i>
                  <span>手机浏览器访问</span>
                </div>
                <div className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-foreground-700 rounded-lg text-sm font-medium border border-background-300/60 cursor-pointer whitespace-nowrap">
                  <i className="ri-wechat-line"></i>
                  <span>关注公众号</span>
                </div>
              </div>
            </div>

            <div className="w-40 h-40 md:w-48 md:h-48 flex items-center justify-center rounded-2xl bg-background-50/80 flex-shrink-0">
              <div className="text-center">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-xl bg-accent-500 text-background-50 mb-3">
                  <i className="ri-smartphone-line text-2xl"></i>
                </div>
                <span className="text-xs font-medium text-foreground-500">扫码访问</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}